export default {
  isPublish: "已发布的",
  isNotPublish: "正在上传",
  dataName: "数据名称",
  validationFuc: "数据验证程序",
  apiDataName: "API名称",
  hasReport: "有无报告",
  dataPrice: "价格",
  dataCode: "数据标识",
  dataPublishTime: "发布时间",
  dataNameIconNo: "无",
  dataNameIconYes: "有",
  dataStatus: "状态",
  dataPublishProgress: "上传进度",
  dataStatusText: {
    1: "上传中",
    2: "上传暂停",
    3: "上传失败",
    4: "上传成功",
  },
  details: {
    pattern: "文件后缀",
    datasetHash: "数据标识",
    apiDatasetHash: "API标识",
    datasetSize: "文件大小",
    isAssessmentReport: "是否有质量验证报告",
    description: "数据描述",
    apiDescription: "API描述",
  },
  checkDetail: "查看详情",
  dataDetail: "数据描述",
  apiDataDetail: "API描述",
  noDataDetail: "数据描述",
  noAPIDataDetail: "暂无API描述",
  dataDeleted: "该数据已删除",
  upload: "数据卖家",
  uploadTime: "发布时间",
  salesVolume: "销量",
  sales: "已售",
  datasetCode: "数据标识：",
  publishTime: "发布时间：",
  preSale: "先验后买",
  peopleCount: "人购买",
  filter: {
    title: "筛选",
    reset: "重置",
    sort: {
      comprehensive: "综合",
      sales: "销量",
      publishTime: "发布时间",
      price: "价格",
    },
  },
  paymentInfo: {
    settlement: "结算",
    cancel: "取消",
    qrLoading: "二维码生成失败",
    scanTip: "请使用微信扫码支付",
    actualPayment: "实付款：",
    qrExpired: "二维码已失效",
  },
  common: {
    dataName: "数据名称：",
    dataImage: "数据图片：",
    noMore: "～没有更多数据了～",
  },
  uploadInfo: {
    success: "上传成功",
    error: "上传失败，请重试",
    imageRequired: "请上传至少一张数据集图片",
    uploading: "正在上传...",
    formatError:
      "文件 {filename} 格式不正确，只能上传JPG/JPEG/PNG/SVG/GIF格式的图片!",
    maxCountError: "已达到最大上传数量{count}张",
    maxSelectError: "最多可以选择6张图片",
    imageSizeTip: "建议尺寸: {size}",
    imageCountTip: "图片数量: 1 ~ {count} 张",
  },
  toolbar: {
    customerService: "客服",
    complaint: "投诉",
    contactSeller: "联系卖家",
  },
  reportTitle: "典枢数据质量验证报告",
  report: "有报告",
  noReport: "无报告",
  dataTag: "数据标签",
  apiDataTag: "API标签",
  fileSize: "文件大小",
  price: "价格",
  apiPrice: "价格",
  suffix: "文件后缀",
  haveReportCount: "有验证报告",
  noReportCount: "无验证报告",
  assessmentReport: "验证报告",
  fileFormat: "文件格式",
  priceDesc: "价格由高到低",
  priceAsc: "价格由低到高",
  relevance: "综合推荐",
  salesVolumeDesc: "销量由高到低",
  salesVolumeAsc: "销量由低到高",
  createTimeDesc: "发布时间倒序",
  createTimeAsc: "发布时间正序",
  totalList: "共搜索到{total}条数据",
  resetTags: "重置标签",
  noDataMarketListTips:
    "没有找到匹配的数据，请将您的需求告诉我们，我们将尽快响应您的需求！",
  releaseRequirements: "发布需求",
  requirementDesc: "需求描述",
  requirementDescPlaceholder: "请输入需求描述",
  publishSuccess: "发布成功",
  publishFailure: "发布失败",
  dataSaler: "数据卖家",
  apiDataSaler: "API卖家",
  salerDesc: "卖家描述",
  dataId: "数据编号",
  priceUnit: "￥",
  apiPriceUnit: "/1次",
  freeText: "限时免费",
  noDataTags: "无数据标签",
  dataQualityReport: "数据质量验证报告",
  qualityReport: "验证报告",
  apiInfo: "API配置信息",
  dataDescription: "数据描述",
  apiDataQualityReport: "API接口配置信息",
  dataQualityReportDesc: "针对该文件格式，典枢提供了{num}种验证方法：",
  dataQualityNoReportNo:
    "目前该文件尚无匹配的数据质量验证程序。我们将在后续版本中提供相应的验证支持，敬请谅解。",
  dataQualityRequest: "卖家暂未授权典枢平台对该文件进行数据验证，您可以向卖家",
  dataQualityNoReport:
    "目前该文件尚无匹配的数据质量验证程序。我们将在后续版本中提供相应的验证支持，敬请谅解。",
  dataQualityHaveReportNo:
    "您可以向卖家提出申请，对数据进行更多、更全面的验证。",
  applyReport: "申请报告",
  applyReport2: "申请验证报告",
  contactSeller: "联系卖家",
  customServices: "客服",
  applyCheck: "申请查看",
  inputing:
    "您可以向卖家说明您申请数据验证报告的原因，以及报告将如何帮助您进行数据验证。",
  complaint: "请输入您的投诉内容，我们将尽快处理您的反馈。",
  notChooseAlgorithm: "请至少选取一个验证方式",
  applicationSubmitted: "申请已提交",
  applicationSubmittedFailed: "申请提交失败",
  reportApplication: "以下为卖家选择提供的数据验证报告：",
  noTags: "暂无标签",
  noDataDescription: "暂无数据描述",
  noSupportAlgorithm: "暂无匹配的验证程序",
  loginFirst: "请先登录, 即将为您跳转到登录页面。",
  sortMethod: "排序方式",
  csv: "电子表格",
  text: "文本",
  video: "视频",
  other: "其他",
  image: "图像",
  zip: "压缩文件",
  api: "API",
  requirementDescTip: "需求描述不能为空。",
  viewAll: "查看完整描述",
  descriptionLoading: "描述内容正在加载，请稍候片刻。",
  hideAll: "收起",
  searchPlaceholder: "请输入数据名称/描述/卖家",
  reportGenerating: "数据报告正在生成中，请您稍后再来查看报告。",
  yuan: "元",
  complaintTip: "数据存在与描述不符、侵权、泄漏隐私等问题？",
  clickHere: "点击此处",
  sensitiveDataLeakage: "敏感数据泄漏",
  infringement: "数据侵权",
  notMatch: "数据与描述不符",
  otherComplaint: "其他原因",
  complaintType: "请选择至少一种举报原因。",
  complaintSuccess:
    "我们已经收到您的投诉，并会立即处理。我们会通过站内信的方式告知您处理结果。",
  complaintFailed: "投诉失败, 请稍后再试。",
  userComplain: "用户投诉",
  apiConfigInfo: {
    basicInfo: "基本信息",
    requestParams: "请求参数",
    requestExample: "请求示例",
    successExample: "成功示例",
    successParamsDescription: "成功参数说明",
    failExample: "失败示例",
    failParamsDescription: "失败参数说明",
    debugResult: "调试结果",
    requestMethod: "请求方式",
    responseType: "返回类型",
    relatedParamsInfoExample: "相关参数信息及示例",
    requestParamsHeaders: "请求参数（Headers）",
    paramName: "参数名",
    noParam: "无参数",
    required: "必填",
    example: "示例",
    description: "描述",
    requestParamsQuery: "请求参数（Query）",
    requestParamsBody: "请求参数（Body）",
    successParams: "成功参数",
    successMessage: "成功信息",
    errorCode: "错误码",
    errorMessage: "错误信息",
    purchaseApi: "购买API",
  },
  buyData: "购买数据",
  payment: "结算",
  buyAgain: "再次购买",
  downloadData: "下载数据",
  downloadReviewedDataTip:
    "此数据开启了交易审核功能， 因此需要卖家审核通过后才可下载该数据。",
  useData: "使用数据",
  wechat: "微信支付",
  purchaseSuccess: "数据已购买成功，您可以在“",
  purchaseSuccess2: "我的API",
  purchaseSuccess3: "”里查看并使用此数据。",
  purchaseDataSuccess: "数据已购买成功，请安装并使用“",
  purchaseDataSuccess2: "典枢客户端",
  purchaseDataSuccess3: "”来下载数据",
  purchaseDataSuccess4: "您也可以在“",
  purchaseDataSuccess5: "”中查看您的购买记录。",
  purchaseDataSuccess6:
    "数据已购买成功，但需注意，该数据需要卖家审核后才能下载。我们建议您与卖家联系，提供相关信息以加快审核进程。",
  purchaseDataSuccess7:
    "数据卖家审核通过后，为了成功下载购买的数据，请安装并使用",
  purchaseDataSuccess8: "。此外，您也可以在“",
  purchaseDataSuccess9: "”中查看您的购买记录。",
  purchaseSuccessShort: "购买成功",
  purchaseFailed: "购买数据失败，请重试",
  myOrders: "我的订单",
  viewDataThere: "中查看此数据",
  scanToPay: "请使用微信扫码支付",
  datasetIdNotExist: "数据集id不存在",
  freeDataMessage:
    "感谢您在典枢购买数据！您可以加入我们的交流群，与其他数据专家互动、交流；更有最新的数据商品咨询和免费数据资源，期待您的加入！",
  times: "次",
  currency: "元",
  priceNote: "因支付金额限制，价格将精确至分。",
  qrCodeGenerating: "支付二维码生成中...",
  sacnToPay: "请使用微信扫码支付。",
  enterPurchaseCount: "请输入购买次数",
  maxPaymentLimit: "单次付款最大限额为6000元",
  minPaymentLimit: "单次付款最小额度为1元",
  safeVerification: {
    title:
      "为确保数据交易的安全与合规性，卖家将对本次交易进行合规性审查。审核通过后，您即可下载数据；若未通过审核，款项将原路退还。",
    label: "双重合规",
  },
  selfHosted: {
    title:
      "数据由卖家托管在其自定义服务器，便于持续维护和更新，确保买家可随时访问最新版本。",
    label: "自主托管",
  },
  enterpriseCertification: {
    title: "认证企业保障",
    label: "该数据由已认证企业发布，数据更有保障。",
  },
};
